import script from "./PromotedProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedProduct.vue?vue&type=script&setup=true&lang=ts"

import "./PromotedProduct.vue?vue&type=style&index=0&id=368f0fe8&lang=css"

const __exports__ = script;

export default __exports__